import Chip from '@/components/Chip/Chip';
import DistrictComponent from './DistrictComponent';
import { useEffect, useState } from 'react';
import { useGetAllowedDomainsQuery } from '@/services/authService/authServiceEndpoints';

interface PreviewHeaderProps {
  setSelectDistrict: (id: string) => void;
  selectDistrict: string;
  setDistrictName: any;
  factSheetName: string;
}

const PreviewHeader = ({
  setSelectDistrict,
  selectDistrict,
  setDistrictName,
  factSheetName,
}: PreviewHeaderProps) => {
  const { data: allowedDomainsData } = useGetAllowedDomainsQuery(undefined);
  const [districtData, setDistrictData] = useState<any[]>([]);

  const handleDistrictChange = (selectedId: string, name: string) => {
    setSelectDistrict(selectedId);
    setDistrictName(name);
  };

  useEffect(() => {
    if (allowedDomainsData && Array.isArray(allowedDomainsData.data)) {
      const data = allowedDomainsData.data;
      setDistrictData(data);

      if (!selectDistrict && data.length > 0) {
        setSelectDistrict(data[0]._id);
        setDistrictName(data[0].name);
        // Use the correct property name, e.g., 'id'
      }
    }
  }, [allowedDomainsData, selectDistrict, setSelectDistrict]);

  return (
    <div className="w-full h-[64px] bg-ds-gray-gray-white px-5 gap-2 rounded-lg flex justify-between items-center shadow-sm">
      {/* Left section */}
      <div className="flex items-center  gap-4">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-ds-gray-600">{factSheetName}</span>
          <span>
            <Chip title={'DRAFT'} size="sm" isFormatting={false} />
          </span>
        </div>
      </div>
      <div className="flex justify-center items-center gap-2">
        <div className="text-ds-gray-300 text-sm">Showing preview for </div>
        <span className="text-ds-gray-600 text-sm font-medium"> District:</span>
        <span>
          <DistrictComponent
            label="District:"
            placeholder="Select District"
            options={districtData}
            onChange={handleDistrictChange}
            value={selectDistrict} // pass selected value if DistrictComponent accepts it
          />
        </span>
      </div>
    </div>
  );
};

export default PreviewHeader;
